import React, { useEffect, useState } from 'react';
import { analytics, initSegment } from 'external-libs/segment';
import { DialogContent, makeStyles } from 'housecall-ui';
import { HCPTheme } from 'housecall-ui/dist/Theme/Theme';

import { useEventTracking } from './hooks/useEventTracking';
import { useOrgData } from './hooks/useOrgData';
import { useOnlineBookingReducer } from './state/useOnlineBookingReducer';
import { HomeOwnerFlowContent } from './HomeOwnerFlowContent';
import { SuccessView } from './SuccessView';

const useStyles = makeStyles((theme: HCPTheme) => ({
  content: {
    backgroundColor: theme.palette.background.main,
    padding: theme.spacing(3),
    paddingBottom: theme.spacing(11.5),
    height: '600px',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '600px',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      maxHeight: 'none',
    },
  },
}));

export const HomeOwnerFlowContentWrapper = () => {
  const { content } = useStyles();
  const {
    state: { orgUuid, success },
  } = useOnlineBookingReducer();

  const { data: orgData, isError } = useOrgData({ orgUuid });
  const [isSegmentInitialized, setIsSegmentInitialized] = useState(false);

  const { trackEvent, trackPage } = useEventTracking({
    pro_impersonated: false,
    email: orgData?.email || '',
    pro_uuid: orgData?.founding_pro_uuid || '',
  });

  useEffect(() => {
    if (orgData && !isSegmentInitialized) {
      initSegment();
      analytics.identify(orgData.founding_pro_uuid, { email: orgData.email });
      trackEvent('Online booking - opened');
      trackPage('Online Booking - Homeowner flow', {
        step: 1,
        step_name: 'categories',
      });
      setIsSegmentInitialized(true);
    }
  }, [orgData, isError, trackEvent, trackPage, isSegmentInitialized]);

  if (!orgUuid) {
    return <DialogContent className={content}>Invalid organization identifier provided</DialogContent>;
  }

  return <DialogContent className={content}>{success ? <SuccessView /> : <HomeOwnerFlowContent />}</DialogContent>;
};
